import React, { FC, useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { PartnerDuplicatesContent } from './components/partnerDuplicatesContent/PartnerDuplicatesContent'
import { PartnerDuplicatesHeader } from './components/partnerDuplicatesHeader/PartnerDuplicatesHeader'
import { IPartnerDuplicatesProps } from './models'

import styles from './PartnerDuplicates.module.scss'

export const PartnerDuplicates: FC<IPartnerDuplicatesProps> = ({
  onClose,
  duplicates,
  isVisible,
  headerActions,
  contentActions,
  contentMessages,
  headerMessages,
  tableAdditionalColumns,
  sortDifference,
  styleClasses,
}) => {
  const hasSamePartner = useMemo(
    () => duplicates && duplicates.some((partner) => partner.isSame),
    [duplicates]
  )

  const contentProps = useMemo(() => {
    return {
      searchResult: duplicates,
      contentActions,
      contentMessages,
      tableAdditionalColumns,
      sortDifference,
      styleClasses,
    }
  }, [
    duplicates,
    contentActions,
    contentMessages,
    tableAdditionalColumns,
    sortDifference,
    styleClasses,
  ])

  return (
    <ModalDialog
      classes={{ window: styles.modalWindow }}
      show={isVisible}
      closeOnOutsideClick={false}
      size={'lg'}
      onClose={onClose}
      contentProps={contentProps}
      header={() => (
        <PartnerDuplicatesHeader
          searchResultCount={duplicates.length}
          hasSamePartner={hasSamePartner}
          headerActions={headerActions}
          headerMessages={headerMessages}
        />
      )}
      content={PartnerDuplicatesContent}
    />
  )
}
